/**
 * Selo `[PARCEIRO]` como o cliente o vê — Regra 6, que o exige em toda
 * superfície de recomendação.
 *
 * Existe porque o portal desenhava o MESMO selo de dois jeitos: o preview da
 * tela "Onde comprar" usava os tokens de marca e o preview do card no wizard de
 * criação usava `bg-blue-100/text-blue-700` do Tailwind. Dois previews da mesma
 * superfície mostrando coisas diferentes é pior que não ter preview: o parceiro
 * escolhe com base no que viu.
 *
 * A cor é a de **informação** da marca, não a turquesa: a Regra 12 reserva a
 * família teal para interação e proíbe nela badge informativo.
 *
 * Fica no app, e não em `@mustauto/ui/web`, porque o que ele resolve é fidelidade
 * de PREVIEW — uma necessidade só do portal do parceiro. O `[PARCEIRO]` do
 * web-admin marca outra coisa (o fornecedor é parceiro MustAuto), e o do mobile é
 * a superfície de verdade. Se um terceiro app precisar previewar a tela do
 * cliente, este componente sobe para o package.
 */
export function PartnerBadge() {
  return (
    <span className="rounded bg-[var(--ma-info-bg-light)] px-1.5 py-0.5 text-[10px] font-bold text-[var(--ma-info-on-light)]">
      [PARCEIRO]
    </span>
  );
}
